export enum LocaleType {
  AU = 'en-AU',
  US = 'en-US',
}
